import { useMemo } from 'react';
import { useUser } from './useUser';
import { USER_ACCESS_ROLES } from '@/config/constant';

/**
 * Custom hook for role-based access control.
 * Supported roles: 'admin' | 'user'  (developer role has been removed).
 */
export const useAuth = () => {
  const { user, isAuthenticated, isLoading } = useUser();

  const userRole = useMemo(() => {
    if (!user?.groups || user.groups.length === 0) {
      return USER_ACCESS_ROLES.USER;
    }
    if (user.groups.includes(USER_ACCESS_ROLES.ADMIN)) return USER_ACCESS_ROLES.ADMIN;
    return USER_ACCESS_ROLES.USER;
  }, [user?.groups]);

  /** Only admins can manage (add / delete) users. */
  const canManageUsers = useMemo(() => userRole === USER_ACCESS_ROLES.ADMIN, [userRole]);

  return {
    user,
    isAuthenticated,
    isLoading,
    userRole,
    canManageUsers,
  };
};

export default useAuth;
